import React, { useEffect, useRef, useState } from 'react'
import * as yup from 'yup'
import InputController from '../../../../Global/InputController'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import Box from '../../../../Global/Box'
import { useMutation, useQuery } from '@apollo/client'
import {
  CREATE_ROUTE_BY_TRUCK,
  GET_ROUTE_BY_ID,
  UPDATE_ROUTE_BY_TRUCK,
} from '../../../../../graphql/Catalog/Trucks/Routes/routesTrucks'
import { useLoading } from '../../../../../LoadingOverlay/LoadingOverlayContext'
import FormWizard from 'react-form-wizard-component'
import StepRoute from './Helpers/StepRoute'
import RoutesTrucksNew from '../RoutesTrucksNew'

const RoutesPlanning = ({
  routeId,
  setRouteId,
  refetchMain,
  refModal,
  setCloseModal,
  closeModal,
  routeIsOnRoute,
}) => {
  const refWizard = useRef()
  const { hideLoading, showLoading } = useLoading()

  const [data, setData] = useState({
    dataStepRoute: false,
    dataStepRequest: false,
  })

  const [isValidSteps, setIsValidSteps] = useState({
    stepRoute: false,
    stepRequest: false,
  })

  const {
    loading: loadingRoute,
    error: errorRoute,
    data: dataRoute,
  } = useQuery(GET_ROUTE_BY_ID, {
    variables: {
      getRouteByIdId: +routeId,
    },
    fetchPolicy: 'cache-and-network',
    skip: !routeId,
  })

  const [createRoute] = useMutation(CREATE_ROUTE_BY_TRUCK)
  const [updateRoute] = useMutation(UPDATE_ROUTE_BY_TRUCK)

  useEffect(() => {
    try {
      if (!routeId) return
      if (loadingRoute) return
      if (errorRoute) throw errorRoute
      if (!dataRoute) throw new Error('No se encontraron datos')

      const { getRouteById } = dataRoute

      setData({
        dataStepRoute: {
          // user_id: getRouteById.user_id,
          truck_id: getRouteById.truck_id,
          plate_number: getRouteById.RouteToTrucks.plate_number,
          scheduled_date: getRouteById.scheduled_date,
          volume: +getRouteById.volume,
        },
      })
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingRoute, errorRoute, dataRoute])

  useEffect(() => {
    if (isValidSteps.stepRoute && isValidSteps.stepRequest) {
      const dataMutation = {
        user_id: +data.dataStepRoute.user_id,
        truck_id: +data.dataStepRoute.truck_id,
        volume: +data.dataStepRoute.volume,
        provider_id: 1,
        scheduled_date: data.dataStepRoute.scheduled_date,
        frequency: 'DAILY',
        inputRoutePoints: data.dataStepRequest.map((requestId) => {
          return {
            water_station_id: +data.dataStepRoute.water_station_id,
            water_truck_request_id: +requestId.id,
          }
        }),
      }

      setData({
        dataStepRoute: false,
        dataStepRequest: false,
      })

      setIsValidSteps({
        stepRoute: false,
        stepRequest: false,
      })

      onSubmit(dataMutation)
    }
  })

  const onSubmit = async (dataRegister) => {
    showLoading()
    try {
      if (routeId) {
        const { data: dataUpdate } = await updateRoute({
          variables: {
            updateRouteId: +routeId,
            route: {
              // user_id: +dataRegister.user_id,
              truck_id: +dataRegister.truck_id,
              volume: +dataRegister.volume,
              provider_id: 1,
              scheduled_date: dataRegister.scheduled_date,
              frequency: 'DAILY',
            },
          },
        })

        if (dataUpdate.updateRoute) {
          await refetchMain()
          return toastSweetAlert({
            mode: 'ok',
            message: 'Ruta actualizada correctamente',
          })
        }
      }
      const { data: dataCreate } = await createRoute({
        variables: {
          route: dataRegister,
        },
      })

      if (dataCreate.createRoute) {
        await refetchMain()
        return toastSweetAlert({
          mode: 'ok',
          message: 'Ruta creada correctamente',
        })
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      setCloseModal(true)
      hideLoading()
    }
  }

  return (
    <>
      <Box
        withCard={false}
        content={
          <>
            {routeId ? (
              <>
                <StepRoute
                  isEdit={routeId ?? false}
                  data={data}
                  setData={setData}
                  submitEdit={onSubmit}
                  routeCompleteOrOnRoute={routeIsOnRoute}
                />
              </>
            ) : (
              <>
                <FormWizard
                  ref={refWizard}
                  backButtonTemplate={() => null}
                  nextButtonTemplate={() => null}
                  finishButtonTemplate={() => null}
                  finishButtonText="Registrar"
                  shape="circle"
                  color="#e74c3c"
                >
                  <FormWizard.TabContent
                    title="Información de la ruta"
                    icon="fas fa-route"
                  >
                    <StepRoute
                      refWizard={refWizard}
                      data={data}
                      setData={setData}
                      setIsValidSteps={setIsValidSteps}
                    />
                  </FormWizard.TabContent>

                  <FormWizard.TabContent
                    title="Solicitudes de pipas"
                    icon="fas fa-map-marked-alt"
                  >
                    <RoutesTrucksNew
                      refWizard={refWizard}
                      dataWizard={data}
                      setDataWizard={setData}
                      setIsValidSteps={setIsValidSteps}
                    />
                  </FormWizard.TabContent>
                </FormWizard>
              </>
            )}
          </>
        }
      />
    </>
  )
}

export default RoutesPlanning
